import type { UserType } from '@/api/types/generated'
import { activationStore } from '@/stores/activation.store'
import { authStore } from '@/stores/auth.store'

interface EnsureSessionOptions {
  requiredUserType?: UserType | undefined
  preloadData?: (() => void) | undefined
}

let authInFlight: Promise<boolean> | null = null

function startSessionData(options: EnsureSessionOptions): void {
  const { userType } = authStore.state
  if (options.requiredUserType && userType !== options.requiredUserType) {
    return
  }
  if (userType === 'candidate') {
    void activationStore.fetch()
  }
  options.preloadData?.()
}

export function ensureSession(options: EnsureSessionOptions = {}): void {
  if (authStore.state.isAuthenticated) {
    void authStore.revalidate()
    authStore.completeBootstrap()
    startSessionData(options)
    return
  }

  if (!authInFlight) {
    authInFlight = authStore.checkAuth().finally(() => {
      authInFlight = null
    })
  }

  void authInFlight.then((authenticated) => {
    if (authenticated) {
      startSessionData(options)
    }
  })
}

export function resetSessionBootstrapForTest(): void {
  authInFlight = null
}
